export default __webpack_public_path__ + "static/media/Dead (3).de92aeee.png";